document.addEventListener( 'DOMContentLoaded', function () {
	/*
	 *	 This move the modals to before </body>
	 */
	const moveModals = document.querySelectorAll( '.block__video .modal' );
	if ( moveModals ) {
		moveModals.forEach( ( moveModal ) => {
			document.querySelector( 'body' ).append( moveModal );
		} );
	}
} );

/*
 * To Reemplaze with Javascript Native
 */

$( document ).ready( function () {
	$( 'button.video.mp4' ).click( function () {
		var theModal = $( this ).data( 'bs-target' ),
			videoSRC = $( this ).attr( 'data-video' ),
			videoSRCauto = videoSRC;
		$( theModal ).find( 'video' ).css( 'display', 'block' );
		$( theModal ).find( 'iframe' ).css( 'display', 'none' );
		$( theModal + ' video source' ).attr( 'src', videoSRCauto );

		setTimeout( function () {
			$( theModal + ' video' )
				.get( 0 )
				.load();
			$( theModal + ' video' )
				.get( 0 )
				.play();
		}, 500 );

		$( theModal + ' button.close' ).click( function () {
			$( theModal + ' video source' ).attr( 'src', videoSRC );
			$( theModal + ' video' )
				.get( 0 )
				.pause();
		} );
	} );
	$( 'button.video.youtube' ).click( function () {
		var theModal1 = $( this ).data( 'bs-target' ),
			videoSRC1 = $( this ).attr( 'data-video' ),
			videoSRCauto1 =
				videoSRC1 +
				'?modestbranding=1&rel=0&controls=1&showinfo=0&html5=1&autoplay=1';
		$( theModal1 ).find( 'video' ).css( 'display', 'none' );
		$( theModal1 ).find( 'iframe' ).css( 'display', 'block' );
		$( theModal1 + ' iframe' ).attr( 'src', videoSRCauto1 );
		$( theModal1 + ' button.close, .modal' ).click( function () {
			$( theModal1 + ' iframe' ).attr( 'src', videoSRC1 );
		} );
	} );
	$( 'button.video.vimeo' ).click( function () {
		var theModal1 = $( this ).data( 'bs-target' ),
			videoSRC1 = $( this ).attr( 'data-video' ),
			videoSRCauto1 = videoSRC1 + '?autoplay=1&loop=1&autopause=0';
		$( theModal1 ).find( 'video' ).css( 'display', 'none' );
		$( theModal1 ).find( 'iframe' ).css( 'display', 'block' );
		$( theModal1 + ' iframe' ).attr( 'src', videoSRCauto1 );
		$( theModal1 + ' button.close, .modal' ).click( function () {
			$( theModal1 + ' iframe' ).attr( 'src', videoSRC1 );
		} );
	} );

	$( document ).on( 'keydown', function ( event ) {
		if ( event.key == 'Escape' ) {
			$( '.embed-responsive-item' ).attr( 'src', '' );
		}
	} );
	$( '.modal[role="dialog"]' ).on( 'hidden.bs.modal', function ( e ) {
		$( '.embed-responsive-item' ).attr( 'src', '' );
	} );
} );
